module.exports = __webpack_public_path__ + "media/images/proof_links/colored/deezer-36a1bc72c8d19309b74a32521fbb4a79.svg";